module.exports = __webpack_public_path__ + "img/PY.f1e07efa.png";